module.exports = __webpack_public_path__ + "img/add photo.24e7cca9.png";